import { preferenceSaveService } from "./preferenceSaveService";
import { propertiesStorage } from "./propertiesStorage";
import { propertiesService } from "./propertiesService";
import defaultI18n from "../i18nService";

const transformSelectValuesList = (selectValues, property, i18n = defaultI18n) => {
    let resultArray = [];
    if(selectValues[0] !== null) {
        selectValues.forEach(it => resultArray.push({
            itemId: it,
            itemTitle: propertiesService.getPropertyValueLocalization(
                it,
                i18n.resolvedLanguage,
                property,
            ),
            included: true,
        }));
    }
    return resultArray;
};

const createJSONString = (listOfData) => {
    const preparedList = [];
    listOfData.forEach(it => preparedList.push(it.itemId));
    return preparedList.length ? JSON.stringify(preparedList) : [];
};

export class preferenceSelectService {
    observersList = [];
    filter = '';
    possibleItems = [];
    selectedItems = [];
    propertyId = '';

    constructor (propertyId) {
        this.propertyId = propertyId;
    }

    getPossibleItems() {
        const currentProperty = propertiesStorage.getById(this.propertyId);
        if(currentProperty && currentProperty.selectValues) {
            this.possibleItems = transformSelectValuesList(
                JSON.parse(currentProperty.selectValues),
                currentProperty,
            ).filter(it => it.itemTitle.toLowerCase().toLowerCase().includes(this.filter));
            return this.possibleItems;
        } else {
            return [];
        }
    }

    getCurrentItems() {
        try {
            const currentValue = preferenceSaveService.getPreference().preferenceItemCodes[0].value;
            if(currentValue) {
                this.selectedItems = transformSelectValuesList(
                    Array.isArray(currentValue) ? currentValue : JSON.parse(currentValue),
                    propertiesStorage.getById(this.propertyId),
                );
            }
            return this.selectedItems;
        } catch (err) {
            return [];
        }
    }

    getPlaceHolder() {
        return "";
    }

    deleteItem(itemId) { 
        this.selectedItems = this.selectedItems.filter(it => it.itemId !== itemId);
        preferenceSaveService.updatePreferencePropertyValue('value', createJSONString(this.selectedItems));
        this.notifyItemsChangingObservers();
    }

    addItem(itemId, i18n = defaultI18n) {
        const property = propertiesStorage.getById(this.propertyId);
        this.selectedItems.push({
            itemId,
            itemTitle: propertiesService.getPropertyValueLocalization(
                itemId,
                i18n.resolvedLanguage,
                property,
            ),
            included: true,
        });
        preferenceSaveService.updatePreferencePropertyValue('value', createJSONString(this.selectedItems));
        this.notifyItemsChangingObservers();
    }

    registerItemsChangingObserver(observer) {
        this.observersList.push(observer);
    }

    unRegisterItemsChangingObserver(observer) {
        try {
            this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
        } catch (err) {
            console.log(err);
        }
    }

    notifyItemsChangingObservers() {
        this.observersList.forEach(observer => observer());
    }

    hasExcludedItemsBlock() {
        return false;
    }

    setSearchFilterValue(searchValue) {
        this.filter = searchValue;
        this.getPossibleItems();
        this.notifyItemsChangingObservers();
    }

    getSearchString() {
        return this.filter;
    }

    isSearchStringChanged() {
        return true;
    }

    handleSearchFilterValue() {}

    getPopupKey() {
        return '';
    }

    getButtonTitle() {
        return '';
    }
}

export const createSelectPreferencePropertyService = (propertyId) => {
    return new preferenceSelectService(propertyId);
};
